import { HttpClient } from '@angular/common/http';
import { APIBaseManager } from '../../api.base';

export interface IUnsubscribeAlertQueryParameter {
    token: string;
    email: string;
    scope: string;
}

export class APIUnsubscribeAlertManager extends APIBaseManager<void, IUnsubscribeAlertQueryParameter, void, void> {
    constructor(protected http: HttpClient) {
        super(http);
        this._apiName = 'API_UnsubscribeAlert';
        this._apiMethod = 'POST';
    }

    protected getRequestURL(pathParameters: void, queryParameters: IUnsubscribeAlertQueryParameter): string {
        return super.getRequestURL() + 'alerts/unsubscribe' + this.transformObjectQueryParameterToStr(queryParameters);
    }
}
